export const withSlash = (value?: string | null) => {
  if (!value) return '';
  return value.endsWith('/') ? value : `${value}/`;
};

export const formatValue = (value: any, fallback = 'Sin registro') => {
  if (value === null || value === undefined || value === '') return fallback;
  return value;
};

export const formatNumber = (value: any, digits = 2, fallback = '0') => {
  if (value === null || value === undefined || value === '') return fallback;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return String(value);
  return numeric.toFixed(digits);
};

export const formatPercent = (value: any) => `${formatNumber(value, 2, '0')}%`;
